'use client'

import { Check, ChevronRight } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { HomeLink } from '@/components/home-link'
import { Button } from '@/components/ui/button'
import { useUnity } from '@/hooks/use-unity'
import teachersLeft from '@/public/img/lado1.webp'
import teachersRight from '@/public/img/lado2.webp'
import seloeMecImg from '@/public/img/selo-e-MEC.webp'
import soeducadorCertificateImg from '@/public/img/soeducador-certificate.webp'

const listInformationAboutCertificate = [
  'Processos seletivos e Concursos Públicos',
  'Progressão Funcional e de Carreira',
  'Carga Horária Complementar na Faculdade',
  'Provas de títulos em residência, mestrado e outros.',
]

export default function CetificateSection() {
  const { unity } = useUnity()
  const isNotEduhot = unity?.reference !== 'UE9E55FE9'

  return (
    <section className="bg-[#36115D] pt-17 pb-8">
      <div className="container">
        <div className="flex flex-wrap items-center justify-center gap-x-16 gap-y-4 lg:flex-nowrap lg:justify-between">
          <Image alt="" height={365.06} src={teachersLeft} width={232} />

          <div className="space-y-3 text-center">
            <h2 className="font-bold text-3.5xl text-white leading-10 md:text-4xl">
              Torne-se um educador de sucesso com um conteúdo que impacta.
            </h2>
            <p className="text-[#C9AADD] text-sm">
              Como educador, é fundamental estar atualizado com os métodos e
              práticas de ensino mais recentes. Nossa plataforma oferece
              conteúdo atual desenvolvido por professores que entendem os
              desafios que você enfrenta em sala de aula.
            </p>

            <Button asChild className="max-w-72">
              <HomeLink className="flex items-center" href={'/cursos'}>
                Comece sua jornada de aprendizado
                <ChevronRight strokeWidth={2.5} />
              </HomeLink>
            </Button>
          </div>

          <Image alt="" height={365.06} src={teachersRight} width={232} />
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-y-12 md:items-start md:justify-between">
          <div className="max-w-96 md:mt-4">
            <h3 className="text-2.5xl text-white leading-8">
              Impulsione sua carreira com certificados reconhecidos
              nacionalmente e validados pelo MEC
            </h3>

            <div className="mt-4">
              <p className="text-[#C9AADD] text-sm">
                Demonstre sua experiência e compromisso com a qualidade do
                ensino. Os certificados da Sóeducador são emitidos pela
                Faculdade FAMEC, instituição credenciada ao Ministério da
                Educação - MEC. Possuem Autenticidade própria e são reconhecidos
                Nacionalmente com a mesma validade de certificados presenciais.
                Destaque-se da multidão e aprimore seu currículo com
                certificados de até 360 horas e treinamento especializado em
                áreas estratégicas da educação.
              </p>
            </div>
          </div>

          <Link
            className="group relative flex items-center rounded-2xl bg-[#F2E8FC] bg-opacity-30 p-4 transition-transform duration-500 hover:scale-105"
            href="/certificado/sobre"
          >
            <Image
              alt="Certificado"
              className="transition-transform duration-500 group-hover:scale-90"
              height={302.25}
              loading="lazy"
              quality="60"
              src={soeducadorCertificateImg}
              width={427.5}
            />

            <Image
              alt="Selo do e-MEC"
              className="-right-8 -top-17 absolute"
              height={114.38}
              src={seloeMecImg}
              width={114.38}
            />
          </Link>

          <div className="max-w-72 md:mt-4">
            <h3 className="text-2.5xl text-white leading-8">
              Use os Certificados da Sóeducador para:
            </h3>

            <div className="mt-4 space-y-4">
              {listInformationAboutCertificate.map(item => (
                <div className="flex items-center gap-2" key={item}>
                  <div className="rounded-full bg-primary-500 p-2">
                    <Check className="size-6 text-gray-100" />
                  </div>
                  <span className="font-medium text-sm text-white">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {isNotEduhot && (
          <div className="mt-4 flex justify-center">
            <Button
              asChild
              className="flex w-1/2 justify-center border border-primary-500 text-primary-500 md:hidden"
              variant="outline"
            >
              <Link href="/certificado/sobre">
                Saiba mais
                <ChevronRight />
              </Link>
            </Button>
          </div>
        )}

        {/* <div className="mx-auto mb-20 mt-12 max-w-27 text-xs md:max-w-35">
          <Button variant="outline" asChild>
            <Link href="/certificado/sobre">
              Saiba Mais
            </Link>
          </Button>
        </div> */}
      </div>
    </section>
  )
}
